<template lang="html">
  <v-container fluid class="px-sm-10">
    <v-row>
      <v-col cols="auto" class="headline">X-Report</v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card>
          <base-items class="d-none" :loadOnTrigger="!selectedPos" storeModule="payments" :filter="paymentsFilter" @items="items = $event" @state="state = $event"></base-items>

          <v-card-title>
            Points Of Sale
          </v-card-title>
          <v-card-text>

            <div v-if="pointsOfSaleLoading" class="">
              <v-progress-circular color="primary" indeterminate></v-progress-circular>
            </div>
            <div v-else-if="pointsOfSaleOptions.length == 0">
              No points of sale
            </div>
            <v-row v-else>
              <v-col
                v-for="pos in pointsOfSaleOptions"
                :key="pos.id"
                cols="auto"
              >
                <v-chip
                  :color="pos.selected ? 'primary' : 'primary'"
                  :outlined="!pos.selected"
                  @click="selectPos(pos.id)"
                >
                  {{pos.name}}
                </v-chip>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-title style="max-width: 29rem;">
            Report
            <v-spacer />
            <v-btn class="" @click="print" color="primary" :disabled="!selectedPos || state.loading">Print</v-btn>
          </v-card-title>

          <v-card-text>
            <div v-if="!selectedPos" class="">
              No point of sale selected. Select one above
            </div>
            <div v-else-if="state.loading || xReportLoading" class="">
              <v-progress-circular color="primary" indeterminate></v-progress-circular>
            </div>
            <div v-else-if="!xReport" class="">
              No X-Report data
            </div>
            <div v-else>
              <div ref="print">
                <div class="xreport-container text--disabled">
                  <x-z-report
                    type="X"
                    :payments="items"
                    :date="reportDate"
                    :org-name="overview.org_name"
                    :org-number="overview.org_number"
                    :point-of-sale="xReport.point_of_sale"
                    :unfinished-items-count="xReport.unfinished_items_count"
                    :unfinished-bills-count="xReport.unfinished_bills_count"
                    :unfinished-amount="xReport.unfinished_amount"
                    :receipts-count="xReport.receipts_count"
                    :receipt-copies-count="xReport.receipt_copies_count"
                    :receipt-copies="xReport.receipt_copies"
                    :grand-total-sales="xReport.grand_total_sales"
                    :grand-total-refund="xReport.grand_total_refund"
                    :grand-total-net="xReport.grand_total_net"
                  ></x-z-report>
                </div>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import XZReport from '../components/XZReport.vue'
import {BaseItems} from 'dync-baseitem'
import axios from 'axios';
import {apiUrl} from '@dynapp/wc-api-generic';
import moment from 'moment-timezone';

export default {
  data () {
    return {
      items: [],
      state: {},
      pointsOfSale: [],
      selectedPos: null,
      xReport: null
    };
  },
  computed: {
    xReportLoading () {
      return this.$store.getters.isLoadingFor('xreport.read');
    },
    pointsOfSaleLoading () {
      return this.$store.getters.isLoadingFor('pointsofsale.read');
    },
    paymentsFilter () {
      var result = {
        keyValue: [
          ['pointOfSale', this.selectedPos]
        ],
        notKey: [
          ['paymentLockId']
        ],
        key: [
          ['serialNumber'],
          ['controlCode']
        ]
      };
      return result;
    },
    overview () {
      const items = this.$store.getters['overviews/items'];
      return items.length > 0 ? items[0] : {};
    },
    reportDate() {
      if (!this.xReport) {
        return '';
      }
      if (this.xReport.date_from) {
        return `${this.xReport.date_from} - ${this.xReport.created_at}`
      } else {
        return this.xReport.created_at;
      }
    },
    pointsOfSaleOptions() {
      var options = this.pointsOfSale.slice(0);
      options = options.map((option) => {
        option = {
          id: option,
          name: (option.match(/FTP\d{3}/) || [''])[0] || option,
          selected: option == this.selectedPos
        };
        return option;
      });
      return options;
    }
  },
  methods: {
    getPointsOfSale() {
      this.$store.commit('startLoading', 'pointsofsale.read');
      var promise = axios.get(apiUrl({dataObject: 'dync-appshop-web'}, '/pointsofsale'));
      promise.then((resp) => {
        this.$store.commit('endLoading', 'pointsofsale.read');
        this.pointsOfSale = resp.data;
      }, () => {
        this.$store.commit('endLoading', 'pointsofsale.read');
        this.$confirm({title: 'Failed', message: 'Failed to get points of sale. Try again?'}).then(this.getPointsOfSale);
      });
      return promise;
    },
    getXReport(pointOfSale) {
      this.$store.commit('startLoading', 'xreport.read');
      var promise = axios.get(apiUrl({dataObject: 'dync-appshop-web'}, `/xreport/${pointOfSale}`));
      promise.then((resp) => {
        this.$store.commit('endLoading', 'xreport.read');
        this.xReport = resp.data;
      }, () => {
        this.$store.commit('endLoading', 'xreport.read');
        this.$confirm({title: 'Failed', message: 'Failed to get X-Report. Try again?'}).then(() => {
          this.getXReport(pointOfSale)
        });
      });
      return promise;
    },
    selectPos(pointOfSale) {
      this.selectedPos = pointOfSale;
      if (this.selectedPos) {
        this.getXReport(this.selectedPos);
      }
    },
    print () {
      var newWindow = window.open();
      var vapp = document.getElementById('app').cloneNode();
      var vwrap = document.getElementsByClassName('v-application--wrap')[0].cloneNode();
      vapp.appendChild(vwrap);
      vwrap.innerHTML = this.$refs.print.innerHTML
      // Copy head for styling and print container for content
      newWindow.document.write(document.head.innerHTML + '\n\n' + vapp.outerHTML);
      // Set title
      newWindow.document.title = `x-report_${(this.overview.name || '').toLowerCase().split(' ').join('_')}_${moment().format('YYYYMMDD_HHMMSS')}`;
      // Poll for page to render before starting print
      var intervalId = setInterval(() => {
        if (newWindow.document.documentElement.offsetHeight > 0) {
          clearInterval(intervalId);
          setTimeout(function () {
            newWindow.print();
            newWindow.close();
          }, 2000);
        }
      }, 100);
    }
  },
  created() {
    this.getPointsOfSale().then(() => {
      this.selectPos(this.pointsOfSale[0]);
    });
  },
  components: {
    XZReport,
    BaseItems
  }
}
</script>

<style lang="scss">
.xreport-container {
  max-width: 27rem;
  border: 1px solid currentcolor;
  padding: 1rem;
}
@media print {
  .xreport-container {
    max-width: 30rem;
    width: 30rem;
    border-color: transparent !important;
    margin: 0 auto !important;
    color: black !important;

    .v-divider {
      background-color: black !important;
      border-color: black !important;
    }
  }
}
</style>
